import { ApiClient } from './base/apiClient';
import type { OutputLoginCardPdfRequest } from '~/types/api/reports/outputLoginCardPdf';

/**
 * ファイル取得系APIのリポジトリクラス
 */
export class FileRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-501] 駅マップPDF取得API
   *
   * @param stationCd 駅コード
   * @param stationSubCd 社線駅サブコード
   * @returns 駅マップPDF
   */
  async getStationMap(
    stationCd: string,
    stationSubCd: string,
  ): Promise<Blob> {
    const query = new URLSearchParams();
    query.append('stationCd', stationCd);
    query.append('stationSubCd', stationSubCd);

    return await this.apiClient.getFile('/station/map', query);
  }

  /**
   * [sp-api-502] 公開用PDF取得API
   *
   * @param filename ファイル名
   * @returns PDFファイル
   */
  async getPublicPdf(
    filename: string,
  ): Promise<Blob> {
    return await this.apiClient.getFile(`/output/public/pdf/${filename}.pdf`);
  }

  /**
   * [sp-api-503] 非公開用PDF取得API
   *
   * @param filename ファイル名
   * @returns PDFファイル
   */
  async getPrivatePdf(
    filename: string,
  ): Promise<Blob> {
    return await this.apiClient.getFile(`/output/private/pdf/${filename}.pdf`);
  }

  /**
   * [sp-api-504] ログインカード（PDF）発行API
   *
   * @param request ログインカードPDF発行対象
   * @returns 発行されたログインカードPDF
   */
  async outputLoginCardPdf(request: OutputLoginCardPdfRequest): Promise<Blob> {
    return await this.apiClient.getFilePost('/reports/login-card', request);
  }
}
